import tw from 'twin.macro';

export const StyledForm = tw.form`h-full flex flex-col justify-between mt-32 mb-12 w-full`;

export const StyledFieldset = tw.fieldset`w-full flex flex-col`;
